const stateBox = "_35ss5teq60";

export { stateBox };
import "./input.facit.style.linaria.module.css";
//# sourceMappingURL=input.facit.style.js.map
